import { schema } from 'normalizr';

const ApplicationVariableConfigurationSchema = new schema.Entity('applicationVariableConfigurations');

export default ApplicationVariableConfigurationSchema;
